// GSAP animation tests
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Observer } from 'gsap/Observer';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { GSDevTools } from 'gsap/GSDevTools';
import { SplitText } from 'gsap/SplitText';
import { BehaviorSubject } from 'rxjs';

gsap.registerPlugin(ScrollTrigger, Observer, ScrollSmoother, GSDevTools, SplitText);
// end GSAP

// splitting using gsap
export function initGSAPSplit() {
  const getAllSplits = document.querySelectorAll('[data-split]');
  //const splitText = new SplitText(Array.from(getAllSplits), { type: 'chars', charsClass: 'test++', style: '--test' });

  getAllSplits.forEach(splitContainer => {
    const splitText = new SplitText(splitContainer, { type: 'chars', charsClass: 'test++', style: '--test' });

    // Get an array of all the character spans
    const charSpans = splitText.chars;

    // Loop through the character spans and set the CSS variable for each element
    charSpans.forEach((charSpan, index) => {
      (<HTMLElement>charSpan).style.setProperty('--char-index', `${index + 1}`);
    });
  });
}

export function scrollTriggerClasses(contentBlockClass: string, batchVars?: ScrollTrigger.BatchVars) {
  const activeScrollTrigger$ = new BehaviorSubject<string[]>([]);

  function enter(elements: Element[]) {
    elements.forEach(a => {
      (<HTMLElement>a).classList.add('scroll--entered');
      const id = a.getAttribute('data-scroll-trigger-id') || a.id;
      if (id) {
        activeScrollTrigger$.next([...activeScrollTrigger$.value, id]);
      }
    });
    //gsap.to(elements, { opacity: 1, stagger: 0.15 });
    //console.log(elements, 'elements entered');
  }
  function leave(elements: Element[]) {
    elements.forEach(a => (<HTMLElement>a).classList.toggle('scroll--entered'));
    //gsap.to(elements, { opacity: 1, stagger: 0.15 });
    //console.log(elements, 'elements left');

    //activeScrollTrigger$.next(
    //  activeScrollTrigger$.value.filter(a => elements.map(el => el.getAttribute('data-scroll-trigger-id')).includes(a))
    //);
    //activeScrollTrigger$.next();
  }

  //console.log('sections', document.querySelectorAll(`.${contentBlockClass}`));

  const scrollTrigger = ScrollTrigger.batch(`.${contentBlockClass}`, {
    onEnter: elements => enter(elements),
    onEnterBack: elements => enter(elements),
    //onLeave: elements => leave(elements),
    //onLeaveBack: elements => leave(elements),
    ...batchVars,
  });

  return activeScrollTrigger$;
}
